import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { AppIconType, Icons } from '@nxsys/types/icons';

const IconWrapper: React.FC<{ icon: AppIconType; color?: string }> = ({
  icon,
  color = defaultTheme.theme.palette.violet[500],
}) => {
  const Icon = Icons[icon];
  return (
    <div className="w-[36px] h-[36px] bg-violet-50 rounded-[6px] p-[8px] flex items-center justify-center">
      <Icon color={color} />
    </div>
  );
};

export default IconWrapper;
